import type { FaireProductEntity } from "../../entity_types/product";

export const driftless_studios_4: FaireProductEntity = {
  token: "driftless-studios-4",
  type: "product",
  name: '"Errbody in the Lake Gettin Tipsy" - Funny Summer Decor',
  brandName: "Driftless Studios",
  imageUrl:
    "https://cdn.faire.com/fastly/dad1865bbef652bc00bebbe8cc2f5773a860a188e9220d22d55135d5e0d5300f.jpeg?bg-color=FFFFFF&dpr=1&fit=crop&format=jpg&height=960&width=720",
  priceDollars: 14.5,
  msrpDollars: 26,
  freeShipping: false,
  isBestseller: false,
  description: "",
  categoryTokens: ["cat_proto_home-and-living"],
  tags: [],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
